import { Component, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-document-history-dialog',
  templateUrl: './document-history-dialog.component.html',
  styleUrls: ['./document-history-dialog.component.scss'],
})
export class DocumentHistoryDialogComponent implements AfterViewInit {
  displayedColumns: string[] = ['userGpid', 'userName', 'role', 'fieldName', 'action', 'actionDate', 'comments'];
  dataSource: MatTableDataSource<any>;

  selectedFieldName: string = '';
  selectedAction: string = '';
  fieldNameOptions: string[] = [];
  actionOptions: string[] = [];

  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DocumentHistoryDialogComponent>
  ) {
    const list = data && Array.isArray(data.docHistoryDtoList) ? data.docHistoryDtoList : [];
    this.dataSource = new MatTableDataSource(list);
    // Extract unique field names and actions for dropdowns
    this.fieldNameOptions = Array.from(new Set<string>(list.map((item: any) => item && item.fieldName).filter((v: any) => v))).sort((a, b) => a.localeCompare(b));
    this.actionOptions = Array.from(new Set<string>(list.map((item: any) => item && item.action).filter((v: any) => v))).sort((a, b) => a.localeCompare(b));
  }

  ngAfterViewInit() {
    // Only assign sort if it's present and has a sortChange stream
    if (this.sort && (this.sort as any).sortChange) {
      this.dataSource.sort = this.sort;
    }

    // Set up filter predicate for dropdowns — be defensive about filter content
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      let filterObj: any = {};
      if (typeof filter === 'string' && filter) {
        try {
          filterObj = JSON.parse(filter);
        } catch (e) {
          // fall back to empty filter on parse errors
          filterObj = {};
        }
      }

      const matchesField = !filterObj.selectedFieldName || (data && data.fieldName) === filterObj.selectedFieldName;
      const matchesAction = !filterObj.selectedAction || (data && data.action) === filterObj.selectedAction;
      return matchesField && matchesAction;
    };
  }

  onCancelClick(): void {
    this.dialogRef.close('ok');
  }

  applyFilter(): void {
    const filterObj = {
      selectedFieldName: this.selectedFieldName,
      selectedAction: this.selectedAction
    };
    this.dataSource.filter = JSON.stringify(filterObj);
  }
}
